<app-iota-modal i18n-title title="Select label" [modalOptions]="modalOptions" (close$)="onCancelClick()">
    <div modal-body>
        <label class="label cursor-pointer flex flex-row gap-2 justify-start" *ngFor="let label of data">
            <input type="checkbox" class="checkbox" color="primary" [value]="label" (change)="updateSelectedLabels($event)" />
            <span class="label-text">{{ getLabelDescription(label) }}</span>
        </label>
    </div>

    <div modal-footer class="flex grow justify-between">
        <div class="flex-1"></div>
        <button class="btn btn-primary" (click)="onSaveClick()" i18n>further</button>
    </div>
</app-iota-modal>
